module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Settings#3-ab7a3e0f58ba3fc98e0fb1b3dfbdb8f5.svg";